import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IListingSortOption } from '@df/catalog-ui/listing/sort/listing-sort';
import { ListingSortComponentDef } from '@df/catalog-ui/listing/sort/listing-sort.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { DropdownComponent } from '../../../ui/display/dropdown/dropdown.component';
import { NListing } from './product-listing.interface';
@Component({
    selector: 'product-listing-sort',
    templateUrl: './product-listing-sort.html',
    standalone: true,
    imports: [DropdownComponent, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListingSortComponent extends ListingSortComponentDef implements NListing.ISort {
    @Input()
    displayAs: 'dropdown' | 'buttons' = 'dropdown';

    isSelected(option: IListingSortOption): boolean {
        return this.sort.selectionLabel === option.label;
    }

    get options() {
        return this.sort.getOptions() || [];
    }

    sortBy(option: undefined | IListingSortOption): void {
        this.sort.by(option);
    }
}
